import React from 'react';
import Button from 'components/CustomButtons/Button.jsx';
import fyndaGenres from 'config/fyndaGenres';

const FavoriteGenresLabels = ({ labels }) => (
  <div>
    {labels.map((e) => (
      <Button
        key={e}
        style={{
          marginRight: '5px',
          borderRadius: '50px',
          backgroundColor: fyndaGenres[e].color,
        }}
      >
        <b
          style={{
            color: '#FFFFFF',
            fontSize: '14px',
          }}
        >
          {e}
        </b>
      </Button>
    ))}
  </div>
);

export default FavoriteGenresLabels;
